import React from 'react';

import {
  ASPECT_RATIO_LANDSCAPE,
  DownloadDefaultIcon,
  DownloadHoverIcon,
  IconTextButton,
  OverviewSlider,
  useSliderViewport,
} from '@mewa/ui';

import { StrapiImage } from '../dynamic-content-page/content-components/image';
import { MediaDownload } from './types';

export const DownloadSlider = React.memo(
  ({ downloads, title }: { downloads: MediaDownload[]; title?: string }) => {
    const viewport = useSliderViewport();

    const slides = downloads.map((download) => {
      if (
        download.thumbnailImage === null &&
        download.mediaToDownload.mime.startsWith('image/')
      ) {
        download.thumbnailImage = download.mediaToDownload;
      }

      return {
        image: (
          <StrapiImage
            alt={download.thumbnailAlternativeText ?? download.caption}
            image={download.thumbnailImage}
          />
        ),
        wrapperLink: <div />,
        linkComponent: (
          <IconTextButton
            HoverIcon={DownloadHoverIcon}
            DefaultIcon={DownloadDefaultIcon}
            sx={{ marginLeft: '-12px' }}
            href={download.mediaToDownload.fields.assetUrl}
            target="_blank"
            rel="noreferrer"
          >
            {download.mediaToDownload.extension.substring(1).toUpperCase()}
          </IconTextButton>
        ),
        description: download.caption,
      };
    });
    return (
      <OverviewSlider
        title={title}
        slides={slides}
        aspectRatio={ASPECT_RATIO_LANDSCAPE}
        viewport={viewport}
      />
    );
  },
);
